import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const linode = defineConnector({
  identifier: "linode",
  name: "Linode",
  tagLine: "Cloud compute and storage by Akamai",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.linode\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Linode API token",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Linode Cloud Manager](https://cloud.linode.com/profile/tokens), go to **My Profile > API Tokens** and create a new **Personal Access Token** with the scopes you need.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "Personal Access Token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.linode.com/v4/profile",
  },
});
